import React from "react";
import { useListContext } from "react-admin";
import { RaGrid } from "ra-compact-ui";
import ShowTitle from "../../../components/ShowTitle";
import {
  DatagridTextField,
  DatagridReferenceTextField,
} from "../../../components";

const LegalPersonReferencesIterator = () => {
  const { ids, data, basePath } = useListContext();

  return (
    <>
      <RaGrid item xs={12}>
        <ShowTitle title="Referencias" />
      </RaGrid>
      {ids.map((id, index) => (
        <RaGrid key={index} container item xs={12}>
          <RaGrid item xs={4}>
            <DatagridReferenceTextField
              resource="legal-people"
              source="referenceTypeId"
              reference="reference-types"
              id={id}
              data={data}
              basePath={basePath}
            />
          </RaGrid>

          <RaGrid item xs={4}>
            <DatagridTextField
              resource="legal-people"
              emptyText="–"
              source="name"
              id={id}
              data={data}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridTextField
              resource="legal-people"
              emptyText="–"
              source="timeAsCustomerYears"
              id={id}
              data={data}
            />
          </RaGrid>
          <RaGrid item xs={12}>
            <DatagridTextField
              resource="legal-people"
              emptyText="–"
              source="address"
              id={id}
              data={data}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridReferenceTextField
              resource="legal-people"
              source="countryId"
              reference="countries"
              id={id}
              data={data}
              basePath={basePath}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridReferenceTextField
              resource="legal-people"
              source="provinceId"
              reference="provinces"
              id={id}
              data={data}
              basePath={basePath}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridReferenceTextField
              resource="legal-people"
              source="cityId"
              reference="cities"
              id={id}
              data={data}
              basePath={basePath}
            />
          </RaGrid>
          <RaGrid item xs={6}>
            <DatagridTextField
              resource="legal-people"
              emptyText="–"
              source="phoneNumber"
              id={id}
              data={data}
            />
          </RaGrid>
          <RaGrid item xs={6}>
            <DatagridTextField
              resource="legal-people"
              emptyText="–"
              source="otherPhoneNumber"
              id={id}
              data={data}
            />
          </RaGrid>
        </RaGrid>
      ))}
    </>
  );
};

LegalPersonReferencesIterator.defaultProps = {
  addLabel: true,
  data: {},
  ids: [],
};

export default LegalPersonReferencesIterator;
